export const TREATMENT_PLAN_JOB_ORIGIN = "job_id";
